import React from 'react';
import { Controller } from 'react-hook-form';
import ErrorMessage from 'app/BargainWidget/Bargains/WidgetV1/components/forms/ErrorMessage';

const NotesFieldV1 = ({ control, label, placeholder, widgetSettings }) => {
  return (
    <Controller
      name="note"
      control={control}
      /* rules={{
        required: 'Note is required!',
        minLength: {
          value: 5,
          message: 'Note must be at least 5 characters long!',
        },
      }} */
      render={({ field: { value, onChange, ...field }, fieldState }) => (
        <div className={" bargain-widget-v1-notes-block"}>
          <label style={{ '--form-label-text-color': widgetSettings?.contentFormLabelColor || '#4b5563' } as any} className="se-text-xs se-font-medium se-text-[var(--form-label-text-color)] se-mb-1.5 se-block bargain-widget-v1-input-field-label">{label}</label>
          <textarea
            {...field}
            value={value}
            onChange={onChange}
            className="se-w-full se-bg-gray-50 se-border-none se-rounded-xl se-p-3.5 se-h-16 focus:se-outline-none focus:se-ring-2 focus:se-ring-indigo-500/20 se-text-gray-800 se-resize-none se-text-sm se-transition-all se-duration-200 bargain-widget-v1-notes-field"
            placeholder={placeholder}
          />
          <ErrorMessage fieldState={fieldState} />
        </div>
      )}
    />
  );
};

export default NotesFieldV1;
